/* eslint-ignore */
// @ts-nocheck
import React, { createContext, useCallback, useContext, useState } from 'react';

const AuthContext = createContext({});

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    const userName = localStorage.getItem('@UltragazEmpresarial:userName');
    const loginEmail = localStorage.getItem('@UltragazEmpresarial:loginEmail');

    const customerType = localStorage.getItem(
      '@UltragazEmpresarial:customerType'
    );
    const document = localStorage.getItem('@UltragazEmpresarial:document');

    const customerName = localStorage.getItem(
      '@UltragazEmpresarial:customerName'
    );
    const customerAddressLine = localStorage.getItem(
      '@UltragazEmpresarial:customerAddressLine'
    );

    const userCustomerRelationshipId = localStorage.getItem(
      '@UltragazEmpresarial:userCustomerRelationshipId'
    );
    const customerId = localStorage.getItem('@UltragazEmpresarial:customerId');
    const customerSiteCode = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteCode'
    );
    const customerCode = localStorage.getItem(
      '@UltragazEmpresarial:customerCode'
    );
    const customerSiteId = localStorage.getItem(
      '@UltragazEmpresarial:customerSiteId'
    );

    const accessToken = localStorage.getItem(
      '@UltragazEmpresarial:accessToken'
    );
    const refreshToken = localStorage.getItem(
      '@UltragazEmpresarial:refreshToken'
    );
    if (accessToken && refreshToken) {
      return {
        userName,
        loginEmail,
        customerType,
        document,
        customerName,
        customerAddressLine,
        userCustomerRelationshipId,
        customerId,
        customerSiteCode,
        customerCode,
        customerSiteId,
        accessToken,
        refreshToken,
      };
    }
    return {};
  });

  const signIn = useCallback(
    async ({ loginEmail, accessToken, refreshToken, customerType }) => {
      localStorage.removeItem('@UltragazEmpresarial:customerSiteCode');
      localStorage.removeItem('@UltragazEmpresarial:customerSiteId');
      localStorage.removeItem('@UltragazEmpresarial:customerCode');
      localStorage.removeItem('@UltragazEmpresarial:customerId');
      localStorage.removeItem('@UltragazEmpresarial:customerName');
      localStorage.removeItem(
        '@UltragazEmpresarial:userCustomerRelationshipId'
      );
      localStorage.removeItem('@UltragazEmpresarial:userName');
      localStorage.removeItem('@UltragazEmpresarial:customerType');
      localStorage.removeItem('@UltragazEmpresarial:userId');

      localStorage.setItem('@UltragazEmpresarial:loginEmail', loginEmail);
      localStorage.setItem('@UltragazEmpresarial:accessToken', accessToken);
      localStorage.setItem('@UltragazEmpresarial:refreshToken', refreshToken);
      localStorage.setItem('@UltragazEmpresarial:customerType', customerType);

      setUserData({
        ...userData,
        loginEmail,
        accessToken,
        refreshToken,
        customerType,
      });
    },
    [setUserData, userData]
  );

  const signOut = useCallback(async () => {
    localStorage.removeItem('@UltragazEmpresarial:customerCode');
    localStorage.removeItem('@UltragazEmpresarial:customerSiteId');
    localStorage.removeItem('@UltragazEmpresarial:customerName');
    localStorage.removeItem('@UltragazEmpresarial:refreshToken');
    localStorage.removeItem('@UltragazEmpresarial:accessToken');
    localStorage.removeItem('@UltragazEmpresarial:userName');
    localStorage.removeItem('@UltragazEmpresarial:document');
    localStorage.removeItem('@UltragazEmpresarial:customerId');
    localStorage.removeItem('@UltragazEmpresarial:customerSiteCode');
    localStorage.removeItem('@UltragazEmpresarial:loginEmail');
    localStorage.removeItem('@UltragazEmpresarial:customerAddressLine');
    localStorage.removeItem('@UltragazEmpresarial:userCustomerRelationshipId');
    localStorage.removeItem('@UltragazEmpresarial:customerType');
    localStorage.removeItem('@UltragazEmpresarial:userId');
    setUserData({});
    window.location.href = '/';
  }, [setUserData]);

  const setUserInfos = useCallback(
    async (infos) => {
      const userValues = { ...userData, ...infos };
      setUserData(userValues);
      localStorage.setItem(
        '@UltragazEmpresarial:userName',
        userValues.userName ||
          localStorage.getItem('@UltragazEmpresarial:userName')
      );
      localStorage.setItem(
        '@UltragazEmpresarial:document',
        userValues.document ||
          localStorage.getItem('@UltragazEmpresarial:document')
      );
      localStorage.setItem(
        '@UltragazEmpresarial:customerName',
        userValues.customerName ||
          localStorage.getItem('@UltragazEmpresarial:customerName')
      );
      localStorage.setItem(
        '@UltragazEmpresarial:customerAddressLine',
        userValues.customerAddressLine ||
          localStorage.getItem('@UltragazEmpresarial:customerAddressLine')
      );
      localStorage.setItem(
        '@UltragazEmpresarial:userCustomerRelationshipId',
        userValues.userCustomerRelationshipId ||
          localStorage.getItem(
            '@UltragazEmpresarial:userCustomerRelationshipId'
          )
      );
      localStorage.setItem(
        '@UltragazEmpresarial:customerId',
        userValues.customerId ||
          localStorage.getItem('@UltragazEmpresarial:customerId')
      );
      localStorage.setItem(
        '@UltragazEmpresarial:customerSiteCode',
        userValues.customerSiteCode ||
          localStorage.getItem('@UltragazEmpresarial:customerSiteCode')
      );
      localStorage.setItem(
        '@UltragazEmpresarial:customerCode',
        userValues.customerCode ||
          localStorage.getItem('@UltragazEmpresarial:customerCode')
      );
      localStorage.setItem(
        '@UltragazEmpresarial:customerSiteId',
        userValues.customerSiteId ||
          localStorage.getItem('@UltragazEmpresarial:customerSiteId')
      );
    },
    [setUserData, userData]
  );

  return (
    <AuthContext.Provider value={{ userData, signIn, signOut, setUserInfos }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
